define("shared/components/shared/post-tagging/tag-dropdown-content", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "shared/types/post-tagging", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _postTagging, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/types/post-tagging",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Input
    @enter={{this.onSubmitNewTag}}
    @value={{this.newTagName}}
    class="cPT__tag-dropdown__input"
    data-test-id="tag-dropdown-input"
    placeholder={{this.placeholder}}
    tabindex="0"
    {{autofocus}}
  />
  <svg
    fill="none"
    height="2"
    preserveAspectRatio="none"
    viewBox="0 0 264 2"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.5 1C103.208 1.00001 160.792 1.00001 263.5 1.00002" stroke="#E8E8EC" />
  </svg>
  <div class="cPT__tag-dropdown__content">
    {{#if this.canCreateNewTag}}
      <Shared::Ui::Button
        @onClick={{this.onSubmitNewTag}}
        @variant="unstyled"
        class="cPT__tag-dropdown__create-btn"
        data-test-id="tag-dropdown-create-button"
      >
        {{svg-jar "add-circle" class="o--icon--md"}}
        {{t (concat "post-tagging.tags." @tagType ".create_new") name=this.newTagName}}
      </Shared::Ui::Button>
    {{else}}
      <div class="cPT__tag-dropdown__label" data-test-id="tag-dropdown-label-container">
        {{svg-jar this.icon class="o--icon u--m__r__sm"}}
        <span data-test-id="tag-dropdown-label-text">{{this.label}}</span>
      </div>
    {{/if}}
    <ul class="cPT__tag-dropdown__container" data-test-id="tag-dropdown-list">
      {{#each this.tags as |tag|}}
        {{#let (has-item @selectedTagIds tag.id) as |isSelected|}}
          <Shared::PostTagging::TagDropdownItem
            @deleteTag={{@deleteTag}}
            @handleSubmitRename={{@handleSubmitRename}}
            @isSelected={{isSelected}}
            @onSelectTag={{@onSelectTag}}
            @shouldReduceZIndex={{@shouldReduceZIndex}}
            @tag={{tag}}
          />
        {{/let}}
      {{/each}}
    </ul>
  </div>
  */
  {
    "id": "v34lcIem",
    "block": "[[[8,[39,0],[[24,0,\"cPT__tag-dropdown__input\"],[24,\"data-test-id\",\"tag-dropdown-input\"],[16,\"placeholder\",[30,0,[\"placeholder\"]]],[24,\"tabindex\",\"0\"],[4,[38,1],null,null]],[[\"@enter\",\"@value\"],[[30,0,[\"onSubmitNewTag\"]],[30,0,[\"newTagName\"]]]],null],[1,\"\\n\"],[10,\"svg\"],[14,\"fill\",\"none\"],[14,\"height\",\"2\"],[14,\"preserveAspectRatio\",\"none\"],[14,\"viewBox\",\"0 0 264 2\"],[14,\"width\",\"100%\"],[14,\"xmlns\",\"http://www.w3.org/2000/svg\",\"http://www.w3.org/2000/xmlns/\"],[12],[1,\"\\n  \"],[10,\"path\"],[14,\"d\",\"M0.5 1C103.208 1.00001 160.792 1.00001 263.5 1.00002\"],[14,\"stroke\",\"#E8E8EC\"],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"cPT__tag-dropdown__content\"],[12],[1,\"\\n\"],[41,[30,0,[\"canCreateNewTag\"]],[[[1,\"    \"],[8,[39,3],[[24,0,\"cPT__tag-dropdown__create-btn\"],[24,\"data-test-id\",\"tag-dropdown-create-button\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"onSubmitNewTag\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"add-circle\"],[[\"class\"],[\"o--icon--md\"]]]],[1,\"\\n      \"],[1,[28,[35,5],[[28,[37,6],[\"post-tagging.tags.\",[30,1],\".create_new\"],null]],[[\"name\"],[[30,0,[\"newTagName\"]]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"cPT__tag-dropdown__label\"],[14,\"data-test-id\",\"tag-dropdown-label-container\"],[12],[1,\"\\n      \"],[1,[28,[35,4],[[30,0,[\"icon\"]]],[[\"class\"],[\"o--icon u--m__r__sm\"]]]],[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"tag-dropdown-label-text\"],[12],[1,[30,0,[\"label\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[10,\"ul\"],[14,0,\"cPT__tag-dropdown__container\"],[14,\"data-test-id\",\"tag-dropdown-list\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"tags\"]]],null]],null],null,[[[44,[[28,[37,10],[[30,3],[30,2,[\"id\"]]],null]],[[[1,\"        \"],[8,[39,11],null,[[\"@deleteTag\",\"@handleSubmitRename\",\"@isSelected\",\"@onSelectTag\",\"@shouldReduceZIndex\",\"@tag\"],[[30,5],[30,6],[30,4],[30,7],[30,8],[30,2]]],null],[1,\"\\n\"]],[4]]]],[2]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@tagType\",\"tag\",\"@selectedTagIds\",\"isSelected\",\"@deleteTag\",\"@handleSubmitRename\",\"@onSelectTag\",\"@shouldReduceZIndex\"],false,[\"input\",\"autofocus\",\"if\",\"shared/ui/button\",\"svg-jar\",\"t\",\"concat\",\"each\",\"-track-array\",\"let\",\"has-item\",\"shared/post-tagging/tag-dropdown-item\"]]",
    "moduleName": "shared/components/shared/post-tagging/tag-dropdown-content.hbs",
    "isStrictMode": false
  });
  let TagDropdownContentComponent = _exports.default = (_class = class TagDropdownContentComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "newTagName", _descriptor2, this);
    }
    get canCreateNewTag() {
      const tagName = this.newTagName.trim().toLowerCase();
      const hasTypedSomething = tagName.length > 0;
      const hasExactMatch = this.args.tagsByType.find(t => t.name.toLowerCase() === tagName);
      return hasTypedSomething && !hasExactMatch;
    }
    get icon() {
      return this.args.tagType === _postTagging.TagType.Campaign ? 'campaign-add' : 'lib-featured-banner';
    }
    get label() {
      return this.intl.t(`post-tagging.tags.${this.args.tagType}.label`);
    }
    get placeholder() {
      return this.args.placeholder ?? this.intl.t(`post-tagging.tags.${this.args.tagType}.add_placeholder`);
    }
    get tags() {
      const trimmedSearch = this.newTagName.trim();
      if (trimmedSearch) {
        const lowerSearch = trimmedSearch.toLowerCase();
        return this.args.tagsByType.filter(t => t.name.toLowerCase().includes(lowerSearch));
      }
      return this.args.tagsByType;
    }
    async onSubmitNewTag() {
      if (this.canCreateNewTag) {
        const newTag = await this.args.createTag(this.newTagName.trim());
        if (newTag) {
          this.newTagName = '';
          this.args.onSelectTag(newTag);
        }
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "newTagName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onSubmitNewTag", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitNewTag"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TagDropdownContentComponent);
});